// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01a8eb29","239":"2e16b84f","732":"75c8864c"}[chunkId] + ".chunk.js";
};